import { render, staticRenderFns } from "./JwKechengAdd.vue?vue&type=template&id=4f6bea1c&scoped=true"
import script from "./JwKechengAdd.vue?vue&type=script&lang=js"
export * from "./JwKechengAdd.vue?vue&type=script&lang=js"
import style0 from "./JwKechengAdd.vue?vue&type=style&index=0&id=4f6bea1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6bea1c",
  null
  
)

export default component.exports